import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import moment from 'moment'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'


import BoxButton from '../Layout/BoxButton'

import { 
	displayModalAddServicio,
	updateInputs,
	addSolicitudServicioItem
} from '../../actions/solicitudservicioot'






class ModalAddServicio extends Component {
	handleCloseModal = (e) => {
		const modal = document.getElementById('modalAddServicio')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalAddServicio .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.displayModalAddServicio(false), 300)
	}

	render() {


		const { modalAddServicio } = this.props
		if (!modalAddServicio.get('show')) {
			return null
		}

		

		return(
			<Modal id="modalAddServicio" show={ true } zindex={ 2000 } width={ 600 } >
				<ModalHeader title={ modalAddServicio.get('title') } onClose={ (e) => this.handleCloseModal(e) } />
				<ModalButtonStrip>
					<BoxButton name="check" disabled={ modalAddServicio.get('btnDisabled') } title="Aceptar" onClick={ () => this.props.addSolicitudServicioItem() } />
				</ModalButtonStrip>
				<ModalBody >
					<div>
						<div className="row">
							<div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Descripción</label>
									<textarea id="Descripcion" className="form-control input-sm" value={  modalAddServicio.getIn(['data', 'descripcion']) || ''  } onChange={ (e) => this.props.updateInputs('modalAddServicio.data.descripcion', e.target.value) } rows={ 3 } />
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md-6">
								<div className="form-group">
									<label className="control-label">Valor del servicio sin IVA</label>
									<input type="number" className="form-control input-sm" value={ modalAddServicio.getIn(['data', 'valor']) || '' } onChange={ (e) => this.props.updateInputs('modalAddServicio.data.valor', e.target.value) } />
								</div>
							</div>

							<div className="col-md-6">
								<div className="form-group">
									<label className="control-label">Valor total del servicio</label>
									<input type="number" className="form-control input-sm" value={ modalAddServicio.getIn(['data', 'valor_con_iva']) || '' } onChange={ (e) => this.props.updateInputs('modalAddServicio.data.valor_con_iva', e.target.value) } />
								</div>
							</div>
						</div>

					</div>
				</ModalBody >
				<ModalFooter >
				</ModalFooter>
			</Modal>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		modalAddServicio: state.solicitudservicioot.get('modalAddServicio'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		displayModalAddServicio: (show) => dispatch(displayModalAddServicio(show)),
		updateInputs: (path, value) => dispatch(updateInputs(path, value)),
		addSolicitudServicioItem: () => dispatch(addSolicitudServicioItem())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddServicio)



// WEBPACK FOOTER //
// ./src/components/SolicitudServicioOT/ModalAddServicio.jsx